import { Page } from "@whitespace/whitespace-ui";
import {
  Col, Row, Tab, Tabs
} from "react-bootstrap";
import { useStateMachine } from "little-state-machine";
import UserHistory from "domains/User/UserHistory/UserHistory";
import { UserTabMode } from "interfaces/UserTabMode";
import { HomeTabMode } from "interfaces/HomeTabMode";
import ManageUser from "domains/User/ManageUser/ManageUser";
import { useNavigate } from "react-router-dom";
import ManageUserGroups from "domains/User/ManageUserGroups/ManageUserGroups";
import ManageUserApplications from "domains/User/ManageUserApplications/ManageUserApplications";
import ManageUserMFAOptions from "domains/User/ManageUserMFAOptions/ManageUserMFAOptions";
import { FlowOrigination } from "interfaces/FlowOrigination";
import { updateUserFilter } from "actions/updateUserFilter";
import { initialUserFilter } from "modules/InitialUserFilter";
import { updateRequestsFilter } from "actions/updateRequestsFilter";
import { initialRequestsFilter } from "modules/initialRequestsFilter";

import AssignUserHwrcSites from "domains/User/ClaimFlows/HWRC/AssignUserHwrcSites/AssignUserHwrcSites";
import AssignUserHwrcRegions from "domains/User/ClaimFlows/HWRC/AssignUserHwrcRegions/AssignUserHwrcRegions";
import AssignUserHwrcRoles from "domains/User/ClaimFlows/HWRC/AssignUserHwrcRoles/AssignUserHwrcRoles";
import AssignWhitespaceUserRoles from "domains/User/ClaimFlows/Whitespace/AssignWhitespaceUserRoles/AssignWhitespaceUserRoles";
import AssignWhitespaceUserAuthorities from "domains/User/ClaimFlows/Whitespace/AssignWhitespaceUserAuthorities/AssignWhitespaceUserAuthorities";
import Users from "./Users/Users";
import Requests from "./Requests/Requests";

interface HomeProps {
  homeTabMode : HomeTabMode,
  userTabMode? : UserTabMode
}

const Home = ({ homeTabMode, userTabMode } : HomeProps) => {
  const { state } = useStateMachine();
  const { actions } = useStateMachine(
    {
      updateUserFilter,
      updateRequestsFilter
    }
  );
  const navigate = useNavigate();

  const handleTabSelect = (key: string | null) => {
    switch (key?.toLowerCase()) {
      case "requests": {
        actions.updateRequestsFilter(initialRequestsFilter());
        navigate("/requests");
        break;
      }
      case "users":
      default:
      {
        actions.updateUserFilter(initialUserFilter());
        navigate("/Users");
      }
    }
  };

  return (
    <>
      <Page>
        <Row>
          <Col>
            <Tabs activeKey={homeTabMode} id="home-tabs" onSelect={key => handleTabSelect(key)}>
              <Tab eventKey="users" title="Users" aria-label="Users" className="p-4 pt-2 border border-top-0">
                {homeTabMode === HomeTabMode.Users
                  && (
                    <>
                      {userTabMode === UserTabMode.Users && <Users />}
                      {userTabMode === UserTabMode.UserHistory && <UserHistory />}
                      {userTabMode === UserTabMode.ManageUser && <ManageUser />}
                      {userTabMode === UserTabMode.ManageUserGroups && <ManageUserGroups />}
                      {userTabMode === UserTabMode.ManageApplications && <ManageUserApplications />}
                      {userTabMode === UserTabMode.ManageMFAOptions && <ManageUserMFAOptions />}

                      {userTabMode === UserTabMode.AssignUserWhitespaceRoles && <AssignWhitespaceUserRoles flowOrigination={FlowOrigination.UserManagement} />}
                      {userTabMode === UserTabMode.AssignUserWhitespaceAuthorities
                      && <AssignWhitespaceUserAuthorities flowOrigination={FlowOrigination.UserManagement} />}

                      {userTabMode === UserTabMode.AssignUserHwrcRoles && <AssignUserHwrcRoles flowOrigination={FlowOrigination.UserManagement} />}
                      {userTabMode === UserTabMode.AssignUserHwrcRegions && <AssignUserHwrcRegions flowOrigination={FlowOrigination.UserManagement} />}
                      {userTabMode === UserTabMode.AssignUserHwrcSites && <AssignUserHwrcSites flowOrigination={FlowOrigination.UserManagement} />}
                    </>
                  )}
              </Tab>
              <Tab eventKey="requests" title="Requests" aria-label="Requests" id="tab-requests" className="p-3 border border-top-0">
                {homeTabMode === HomeTabMode.Requests
                  && (
                    <>
                      {userTabMode === UserTabMode.Requests && <Requests /> }
                      {userTabMode === UserTabMode.AssignUserWhitespaceRoles && <AssignWhitespaceUserRoles flowOrigination={FlowOrigination.Requests} />}
                      {userTabMode === UserTabMode.AssignUserWhitespaceAuthorities
                      && <AssignWhitespaceUserAuthorities flowOrigination={FlowOrigination.Requests} />}
                      {userTabMode === UserTabMode.AssignUserHwrcRoles && <AssignUserHwrcRoles flowOrigination={FlowOrigination.Requests} />}
                      {userTabMode === UserTabMode.AssignUserHwrcRegions && <AssignUserHwrcRegions flowOrigination={FlowOrigination.Requests} />}
                      {userTabMode === UserTabMode.AssignUserHwrcSites && <AssignUserHwrcSites flowOrigination={FlowOrigination.Requests} />}
                    </>
                  )}
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Page>
    </>
  );
};
export default Home;
